import styled from 'styled-components';

import { Button, TextButton } from '@xing-com/button';
import {
  Headline as LayoutHeadline,
  BodyCopy as LayoutBodyCopy,
} from '@xing-com/crate-login-layout';
import { Hyperlink as BreweryHyperlink } from '@xing-com/hyperlink';
import { mediaConfined } from '@xing-com/layout-tokens';
import {
  scale080,
  spaceL,
  spaceM,
  spaceXL,
  spaceXS,
  spaceXXL,
} from '@xing-com/tokens';

const Container = styled.div`
  width: 100%;

  @media ${mediaConfined} {
    max-width: 380px;
  }
`;

const CheckBoxContainer = styled.div`
  display: none;
  margin-bottom: ${spaceXL};
  align-items: center;

  @media ${mediaConfined} {
    display: inline-flex;
  }
`;

const InputWrapper = styled.div`
  margin-bottom: ${spaceXL};
`;

const HeadlineContainer = styled.div`
  margin-bottom: ${spaceXXL};
`;

const Headline = styled(LayoutHeadline)`
  margin-bottom: ${spaceXS};
`;

const TextCenter = styled.div`
  margin-top: ${spaceM};
  text-align: center;
`;

const Label = styled.label`
  font-size: ${scale080};
  padding-left: ${spaceM};
  cursor: pointer;
  align-self: center;
`;

const TroubleLoggingInLink = styled(TextButton)`
  margin-top: ${spaceL};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1em;
  text-decoration: underline;
`;

const TandC = styled(LayoutBodyCopy)`
  margin-top: ${spaceXL};
  margin-bottom: 0;
  text-align: center;
  a {
    text-decoration: underline;
  }
`;

const SubmitButton = styled(Button)`
  width: 100%;
`;

const Hyperlink = styled(BreweryHyperlink)`
  text-decoration: underline;
`;

export const Styled = {
  Container,
  CheckBoxContainer,
  InputWrapper,
  TextCenter,
  Label,
  SubmitButton,
  HeadlineContainer,
  Headline,
  TroubleLoggingInLink,
  TandC,
  Hyperlink,
};
